
<template>
  <Card>
    <template slot="title">
      <Breadcrumb>
        <BreadcrumbItem to="/wareList">仓库信息</BreadcrumbItem>
        <BreadcrumbItem>{{
          currentType == 1 ? "编辑" : "新增"
        }}</BreadcrumbItem>
      </Breadcrumb>
    </template>
    <router-link to="/wareList" slot="extra">返回</router-link>
    <Form
      :style="{ width: '400px', margin: '0 auto' }"
      ref="formValidate"
      :model="formInline"
      :rules="ruleValidate"
    >
      <FormItem label="资金商" prop="spCode">
        <Select
          v-model="formInline.spCode"
          placeholder="请选择资金商"
          :disabled="currentType == 1 ? true : false"
        >
          <Option
            v-for="(item, index) in spList"
            :key="index"
            :value="item.code"
            >{{ item.name }}</Option
          >
        </Select>
      </FormItem>
      <FormItem label="仓库名称" prop="wmsName">
        <Input
          type="text"
          v-model="formInline.wmsName"
          placeholder="请输入仓库名称"
        ></Input>
      </FormItem>

      <!-- 新增字段 -->
      <FormItem label="仓库简称" prop="shortName">
        <Input
          type="text"
          v-model="formInline.shortName"
          placeholder="请输入仓库简称"
        ></Input>
      </FormItem>

      <FormItem label="送达方编码" prop="shipToCode">
        <Input
          type="text"
          v-model="formInline.shipToCode"
          placeholder="请输入送达方编码"
          :disabled="currentType == 1 ? true : false"
        ></Input>
      </FormItem>
      <FormItem label="送达方名称" prop="shipToName">
        <Input
          type="text"
          v-model="formInline.shipToName"
          placeholder="请输入送达方名称"
        ></Input>
      </FormItem>

      <!-- 新增 -->
      <Form-item label="仓库所属区域" prop="wmsAddressInfo">
        <Cascader
          :data="addressData"
          v-model="address"
          @on-change="addChange"
        ></Cascader>
      </Form-item>

      <FormItem label="仓库详细地址" prop="wmsAddress">
        <Input
          type="text"
          v-model="formInline.wmsAddressInfo.address"
          placeholder="请输入仓库详细地址"
        ></Input>
      </FormItem>
      <FormItem label="主体编码" prop="subjectCode">
        <Input
          type="text"
          v-model="formInline.subjectCode"
          placeholder="请输入主体编码"
        ></Input>
      </FormItem>
      <FormItem label="三方仓库编码" prop="thirdPartyCode">
        <Input
          type="text"
          v-model="formInline.thirdPartyCode"
          placeholder="请输入三方仓库编码"
        ></Input>
      </FormItem>
      <!-- <FormItem label="接收系统账号" prop="receivedAccount">
        <Input
          type="text"
          v-model="formInline.receivedAccount"
          placeholder="请输入接收系统账号"
        ></Input>
      </FormItem>
      <FormItem label="接收系统编码" prop="receivedCode">
        <Input
          type="text"
          v-model="formInline.receivedCode"
          placeholder="请输入接收系统编码"
        ></Input>
      </FormItem>
      <FormItem label="特征参数" prop="featureArgs">
        <Select
          v-model="formInline.featureArgs"
          placeholder="请选择特征参数"
          clearable
        >
          <Option
            v-for="(item, index) in features"
            :key="index"
            :value="item.value"
            >{{ item.name }}</Option
          >
        </Select>
      </FormItem>
      <FormItem label="备注" prop="remark">
        <Input
          type="text"
          v-model="formInline.remark"
          placeholder="请输入接收系统编码"
        ></Input>
      </FormItem> -->
      <FormItem>
        <Button type="primary" @click="handleSubmit('formValidate')"
          >保存</Button
        >
        <Button @click="handleReset('formValidate')" style="margin-left: 8px"
          >重置</Button
        >
      </FormItem>
    </Form>
  </Card>
</template>
<script>
export default {
  data() {
    const validateAddress = (rule, value, callback) => {
      if (this.formInline.wmsAddressInfo.address) {
        callback();
      } else {
        callback(new Error("详细地址不能为空"));
      }
    };
    const validateAddress1 = (rule, value, callback) => {
      if (this.formInline.wmsAddressInfo.provinceName) {
        callback();
      } else {
        callback(new Error("仓库所属区域不能为空"));
      }
    };
    return {
      currentType: 0,
      formInline: {
        // featureArgs: "",
        // receivedAccount: "",
        // receivedCode: "",
        shipToCode: "",
        shipToName: "",
        spCode: "",
        // wmsAddress: "",
        wmsName: "",
        // remark: "",
        // 新增
        shortName: "",
        subjectCode: "",
        thirdPartyCode: "",
        wmsAddressInfo: {
          address: "",
          provinceId: "",
          provinceName: "",
          cityId: "",
          cityName: "",
          countyId: "",
          countyName: "",
          streetId: "",
          streetName: "",
        },
      },
      wmsCode: "",
      spList: [],
      features: [
        { name: "无", value: "" },
        { name: "渝欧爱蕴美", value: "渝欧爱蕴美" },
      ],
      ruleValidate: {
        wmsName: [
          { required: true, message: "请输入仓库名称", trigger: "blur" },
        ],
        spCode: [
          { required: true, message: "请选择资金商", trigger: "change" },
        ],
        shipToCode: [
          { required: true, message: "请输入送达方编码", trigger: "blur" },
        ],
        // 新增
        wmsAddress: [
          { required: true, validator: validateAddress, trigger: "blur" },
        ],
        subjectCode: [
          { required: true, type: "string", message: "请输入主体编码" },
        ],
        thirdPartyCode: [
          { required: true, type: "string", message: "三方仓库编码" },
        ],
        wmsAddressInfo: [
          { required: true, validator: validateAddress1, trigger: "change" },
        ],
      },
      originAddress: [],
      addressData: [],
      address: [],
    };
  },
  created() {
    this.getOption();
    this.getData();
    this.getBaseAreaQueryAll();
  },
  methods: {
    getData() {
      let q = this.$route.query;
      if (q.spCode) {
        this.currentType = 1;
        let data = {
          shipToCode: q.shipToCode,
          spCode: q.spCode,
          wmsCode: q.wmsCode,
        };
        this.$api["wareDetail"](data).then((res) => {
          if (res.code == "200") {
            let d = res.data;
            Object.keys(this.formInline).forEach((key) => {
              this.formInline[key] = d[key];
            });
            if (!d.wmsAddressInfo) {
              this.formInline.wmsAddressInfo = [];
            }
            this.wmsCode = d.wmsCode;
            if (d.wmsAddressInfo) {
              let wmsAddressInfo = d.wmsAddressInfo;
              let address = [
                `${wmsAddressInfo.provinceName}`,
                `${wmsAddressInfo.cityName}`,
                wmsAddressInfo.countyName,
              ];
              this.$set(this, "address", address);
            }
          }
        });
      }
    },
    getOption() {
      this.$api["spSearchAll"]({}).then((res) => {
        if (res.code == "200") {
          this.spList = res.data;
        }
      });
    },
    handleSubmit(name) {
      let data = { ...this.formInline };
      let path = "wareAdd";
      if (this.currentType == 1) {
        path = "wareUpdate";
        data.wmsCode = this.wmsCode;
      }
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$api[path](data).then((res) => {
            if (res.code == "200") {
              this.$Message.success("操作成功");
              this.$router.replace({ path: "/wareList" });
            }
          });
        }
      });
    },
    handleReset(name) {
      this.address = [];
      for (let key in this.formInline.wmsAddressInfo) {
        this.formInline.wmsAddressInfo[key] = "";
      }
      if (this.currentType == 0) {
        this.$refs[name].resetFields();
      } else {
        this.$refs[name].fields.forEach((item) => {
          if (item.prop !== "spCode" && item.prop !== "shipToCode") {
            item.resetField();
          }
        });
      }
    },
    async getBaseAreaQueryAll() {
      return new Promise((reslove) => {
        this.$api.areaQueryAll().then((res) => {
          if (res.code == 200) {
            this.originAddress = res.data;
            this.addressData = this.convertAddressTree(res.data);
            reslove(this.addressData);
          }
        });
      });
    },
    convertAddressTree(data) {
      const result = [];
      data.forEach((item) => {
        let { name: value, name: label, children } = item;
        if (children) {
          children = this.convertAddressTree(children);
        }
        result.push({ value, label, children });
      });
      return result;
    },
    addChange(e) {
      let addInfo = this.formInline.wmsAddressInfo;
      addInfo.provinceName = e[0];
      addInfo.cityName = e[1];
      addInfo.countyName = e[2];
      this.originAddress.forEach((item) => {
        if (item.name == e[0]) {
          addInfo.provinceId = item.code;
          item.children.forEach((item0) => {
            if (item0.name == e[1]) {
              addInfo.cityId = item0.code;
              item0.children.forEach((item1) => {
                if (item1.name == e[2]) {
                  addInfo.countyId = item1.code;
                }
              });
            }
          });
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/warehouse/wareAdd.vue